import { Helmet } from 'react-helmet-async';
import { getBreadcrumbListSchema } from '../../utils/schemaGenerator';

interface BreadcrumbListSchemaProps {
  /**
   * Current pathname from useLocation().
   * Used to generate breadcrumbs automatically.
   */
  pathname: string;
}

/**
 * BreadcrumbListSchema component generates JSON-LD BreadcrumbList structured data.
 * Automatically generates breadcrumbs based on the current route pathname.
 * Enables breadcrumb navigation in search results and improves SEO.
 *
 * @param pathname Current pathname (from useLocation)
 */
export default function BreadcrumbListSchema({
  pathname,
}: BreadcrumbListSchemaProps) {
  const schema = getBreadcrumbListSchema(pathname);

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
}
